import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { motion } from "motion/react";
import { cn } from "@/utils/utils";
import { SafeAreaContainer } from "@/components/layout/safe-area-container";
import { Loader2 } from "lucide-react";

export const Route = createFileRoute("/events/mcn-project")({
  component: McnProjectPage,
});


const CARD_BG_CLASS = "bg-[#faf5eb]";
const PAGE_BG_IMAGE = "/images/event/mcn-proj-bg.webp";
const HEADER_TOP_IMAGE = "/images/event/mcn-proj-top.webp";
const TITLE_ART_SRC = "/img/event/mcn-project/title_art.png";
const PRIZE_IMAGE = "/images/event/mcp-profit.png";
const PAGE_BG_IMAGE_2 = "/images/event/mcn-proj-bg-2.webp";

// 活动卡片外边框样式 - 星火燎原主题
const CARD_WRAPPER_CLASS = cn(
  "relative",
  // 外发光效果
  "before:absolute before:-inset-[3px] before:rounded-2xl before:bg-gradient-to-br",
  "before:from-amber-400/60 before:via-orange-500/50 before:to-red-500/40",
  "before:blur-[2px] before:-z-10",
  // 金色渐变边框
  "after:absolute after:-inset-[2px] after:rounded-2xl after:-z-10",
  "after:bg-gradient-to-br after:from-amber-300 after:via-orange-400 after:to-amber-500",
);

// 标签外边框样式
const TAB_WRAPPER_CLASS = cn(
  "relative",
  "before:absolute before:-inset-[2px] before:rounded-xl before:-z-10",
  "before:bg-gradient-to-br before:from-amber-300 before:via-orange-400 before:to-amber-500",
);

// 星火燎原计划 活动页
export default function McnProjectPage() {
  const [headerImgFailed, setHeaderImgFailed] = useState(false);
  const [titleImgFailed, setTitleImgFailed] = useState(false);
  const [prizeImgFailed, setPrizeImgFailed] = useState(false);
  const [buttonText, setButtonText] = useState("参与报名");
  const [buttonLoading, setButtonLoading] = useState(false);
  // const [isPaintUser, setIsPaintUser] = useState(false);

  // const { userInfo, isAuthenticated } = useAuth();

  // useEffect(() => {
  //   if (isAuthenticated) {
  //     if (userInfo.role?.painter?.artist || userInfo.role?.painter?.template) {
  //       setIsPaintUser(true);
  //       setButtonText("报名参与");
  //     } else {
  //       setIsPaintUser(false);
  //       setButtonText("暂无报名资格");
  //     }
  //   } else {
  //     setIsPaintUser(false);
  //     setButtonText("暂无报名资格");
  //   }
  // }, [userInfo, isAuthenticated]);

  const handleSignUp = () => {
    if (buttonLoading) return;
    // 跳转报名页
    setButtonLoading(true);
    setButtonText("正在打开问卷...");
    window.open("https://docs.qq.com/form/page/DTktJbkhGdndFdm14", "_blank");
  };

  return (
    <SafeAreaContainer
      fullHeight
      className="relative min-h-dvh w-full overflow-x-hidden"
      customPaddingBottom="24px"
    >
      {/* 背景图 */}
      <div
        className="absolute inset-0 -z-10 min-h-dvh bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${PAGE_BG_IMAGE})` }}
        aria-hidden
      />

      <div className="mcn-page-bg relative flex min-h-dvh w-full flex-col px-4 pb-6 pt-4"
        style={{
          backgroundImage: `url(${PAGE_BG_IMAGE_2})`,
          backgroundSize: "contain",
          backgroundPosition: "bottom",
          backgroundRepeat: "no-repeat",
        }}>
        {/* 顶部插画：移动端占满，桌面端限制宽度，开始日期固定在内侧下方 */}
        <div className="mcn-header-illustration flex justify-center">
          <div className="relative w-full md:max-w-2xl">
            {!headerImgFailed ? (
              <img
                src={HEADER_TOP_IMAGE}
                alt=""
                className="h-auto w-full object-contain"
                onError={() => setHeaderImgFailed(true)}
              />
            ) : (
              <div className="flex aspect-[4/3] w-full items-center justify-center rounded-xl bg-amber-200/50 text-sm text-amber-700">
                顶部插画占位
              </div>
            )}
            <p className="absolute bottom-0 left-4 right-4 text-center text-base font-extrabold leading-[22px]">
              <span
                className={cn(
                  "inline-block rounded-full px-4 py-1.5 text-white",
                  "bg-black/55 shadow-[0_1px_4px_rgba(0,0,0,0.4)]",
                  "[text-shadow:0_1px_2px_rgba(0,0,0,0.6)]",
                )}
              >
                开始日期：2026.1.31
              </span>
            </p>
          </div>
        </div>

        {/* 艺术字标题 */}
        <div className="mt-2 flex flex-col items-center gap-1">
          <div className="mcn-title-image relative w-full max-w-[280px]">
            {!titleImgFailed && (
              <img
                src={TITLE_ART_SRC}
                alt="星火燎原计划"
                className="h-auto w-full object-contain"
                onError={() => setTitleImgFailed(true)}
              />
            )}
          </div>
        </div>

        {/* 活动介绍 */}
        <section className="mt-6">
          <div className={cn(TAB_WRAPPER_CLASS, "-mb-2.5 ml-4 inline-block")}>
            <div
              className={cn(
                "relative rounded-xl px-4 py-1.5 text-[22px] font-bold text-amber-900",
                CARD_BG_CLASS,
              )}
            >
              活动介绍
            </div>
          </div>
          <div className={CARD_WRAPPER_CLASS}>
            <div
              className={cn(
                "relative rounded-2xl p-4 text-sm font-medium leading-relaxed新· text-black",
                CARD_BG_CLASS,
              )}
            >
              <p className="text-center text-md font-bold text-amber-900 mb-4 mt-1">谁说星火不能燎原？我们相信，每个小画师都值得被看见！</p>
              <p>
                我们在新的一年开通了全平台的官方账号！加入我们！提供您的作品或作品绘制过程，我们将为您定制专属的宣传视频在各个官方社交平台发布为您带来海量流量！愿我们和各位创作者共同成长，越走越远！
              </p>
              <p>
                我们的全平台官方账号名称：
                <span className="font-semibold text-red-600">兽聚汇_official</span>
              </p>
              <p className="mt-4">
                参与活动还可领取今年春节窗贴一份哟~
              </p>
            </div>
          </div>
        </section>

        {/* 奖品设置 */}
        <section className="mt-5">
          <div className={cn(TAB_WRAPPER_CLASS, "-mb-2.5 ml-4 inline-block")}>
            <div
              className={cn(
                "relative rounded-xl px-4 py-1.5 text-[22px] font-bold text-amber-900",
                CARD_BG_CLASS,
              )}
            >
              奖品设置
            </div>
          </div>
          <div className={CARD_WRAPPER_CLASS}>
            <div
              className={cn(
                "relative rounded-2xl p-4 text-sm font-medium leading-relaxed text-black",
                CARD_BG_CLASS,
              )}
            >
              <div className="text-center text-2xl font-bold text-amber-900 mb-4 mt-1">
                2026 · 新年窗贴
              </div>
              {/* 奖品预览图 */}
              <div className="mb-4 flex justify-center max-h-[500px]">
                {!prizeImgFailed ? (
                  <img
                    src={PRIZE_IMAGE}
                    alt="新年窗贴奖品预览"
                    className="h-auto w-full rounded-lg object-contain shadow-md"
                    onError={() => setPrizeImgFailed(true)}
                  />
                ) : (
                  <div className="flex aspect-square w-full max-w-[300px] items-center justify-center rounded-lg bg-amber-100 text-xs text-amber-600">
                    奖品图片加载失败
                  </div>
                )}
              </div>

              <ol className="list-decimal space-y-2 pl-4">
                <li>
                  新年期间每位参与星火燎原计划的小伙伴都可以领取一份新年窗贴哟~
                </li>
                <li>
                  我们每周都将在抖音、B站、小红书、快手的官方账号中，发布为您制作的个人作品推广视频/图文，为您提高名气及曝光量！
                </li>

                <li>知己知彼方能百战百胜！您将拥有更多的与官方合作及曝光的机会！</li>
              </ol>
              <p className="mt-3 text-xs text-red-600">
                注：本次窗贴奖品，因制作和运输成本较高，我们将会统一收取5元运费（剩余的部分已由平台承担）。如果您决定不需要奖品，可以选择不填写地址和支付运费。感谢大家的理解与支持！
              </p>
            </div>
          </div>
        </section>

        {/* 参与方式 */}
        <section className="mt-5">
          <div className={cn(TAB_WRAPPER_CLASS, "-mb-2.5 ml-4 inline-block")}>
            <div
              className={cn(
                "relative rounded-xl px-4 py-1.5 text-[22px] font-bold text-amber-900",
                CARD_BG_CLASS,
              )}
            >
              参与方式
            </div>
          </div>
          <div className={CARD_WRAPPER_CLASS}>
            <div
              className={cn(
                "relative rounded-2xl p-4 text-sm font-medium leading-relaxed text-black",
                CARD_BG_CLASS,
              )}
            >
              本次活动模板及常稿认证画师均可参加，您可通过下面的步骤来参与本次活动：
              <ol className="list-decimal space-y-2 pl-4">
                <li>
                  点击下方「报名参与」，前往腾讯问卷。
                </li>
                <li>
                  在问卷中上传四张您认为完成度最高的作品参与评选；模板画师请上传您改模程度最好的四张作品参与评选哟~
                </li>
                <li>
                  填写您的联系方式及收货地址，便于我们向您寄送参与奖品。
                </li>
                <li>
                  我们的客服将会联系符合要求的老师来建立合作关系，请保持联系方式畅通～
                </li>
              </ol>
            </div>
          </div>
        </section>

        {/* 底部报名按钮 */}
        <div className="mt-8 flex justify-center px-2 flex-col items-center gap-4">
          <div className="mt-4 text-center text-sm text-white bg-gradient-to-r from-amber-400 via-orange-400 to-amber-500 border-2 border-white/90 shadow-lg p-2 rounded-lg">
            本次活动需要您拥有模板或常稿认证画师资格，请您先通过画师认证再来报名哦～
          </div>
          <motion.div
            className="w-full max-w-[320px]"
            animate={
              buttonLoading ? {
                scale: [1, 1, 1],
              } : {
                scale: [1, 1.1, 1],
              }
            }
            transition={{
              duration: 2,
              repeat: Infinity,
              repeatType: "loop",
              ease: "easeInOut",
            }}
          >
            <motion.button
              disabled={buttonLoading}
              whileTap={{ scale: 0.9, rotate: 3 }}
              onClick={handleSignUp}
              className={cn(
                "h-16 w-full rounded-xl text-xl font-bold text-white",
                "border-2 border-white/90 shadow-lg",
                "bg-gradient-to-r from-amber-400 via-orange-400 to-amber-500",
              )}
            >
              <div className="flex items-center justify-center gap-2">
                {buttonLoading ? <Loader2 className="animate-spin" /> : null}
                {buttonText}
              </div>
            </motion.button>
          </motion.div>
        </div>
      </div>
    </SafeAreaContainer>
  );
}
